"use client";
import { FC } from "react";

import { useAuth } from "./CognitoAuthContext";

export default function renderOnInternalUser<T>(Component: FC<T>) {
  return (props: T extends JSX.IntrinsicAttributes ? any : any) => {
    const { isInternalUser } = useAuth().user!;

    if (isInternalUser) {
      return <Component {...props} />;
    }

    return null;
  };
}
